import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { bandDescriptorsData, getDataForDifficulty } from './data/skills/writing/bandDescriptors';

export default function BandDescriptors() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : bandDescriptorsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
